module.exports = __webpack_public_path__ + "d660886eed486ec140df79930342347a.pdf";